<template>
  <div class="wanfa">
    <img
      class="title"
      src="https://picbed.qunarzz.com/26124c1c9c358bc2d356f2202a45ca3b.png"
      alt=""
    />
    <div class="wanfaItem-box clear">
      <div v-maidian="item.id" @click="jumpUrl(item.link)" v-for="(item,index) in imgList" :key="index" class="wanfaItem">
        <div class="wanfaItem-banner">
          <img
            :src="item.img"
            alt=""
          />
        </div>
        <div class="wanfaItem-content">
          <div class="wanfaItem-name text-overflow">
            {{item.title}}
          </div>
          <div class="wanfaItem-bottom">
            <div class="price">{{item.price}}</div>
            <div class="button">
              <a>立即购买</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a v-maidian="'gonglv_lookmore'" href="https://touch.dujia.qunar.com/p/list?appshared=1&dep=%E6%9D%AD%E5%B7%9E&query=%E6%BE%B3%E9%97%A8&mobFunction=%E8%87%AA%E7%94%B1%E8%A1%8C&date=&qsact=filter&itineraryday=4%2C2%2C3%2C5&configDepNew=%E6%9D%AD%E5%B7%9E">
      <img
        src="https://picbed.qunarzz.com/4e6477cdf32ec970ce3463c15ae2f8a8.png"
        class="lookMore"
        alt=""
      />
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentIndex: 0,
      imgList:[
          {
              img:'https://imgs.qunarzz.com/vs_ceph_vs_tts/d81245e9-145a-4ecf-80dc-6c47c5c0bee2.jpg_480x320_b502bad9.jpg',
              link:'https://fh.dujia.qunar.com/fhxtouch/detail/351130833_?in=2021-05-08&productId=51505521&dep=%E6%9D%AD%E5%B7%9E&query=%E6%BE%B3%E9%97%A8&newfreetrip=1',
              id:'wanfa_1',
              price:'1837',
              title:'「澳门自由行•住澳门励庭海景酒店或其他」'
          },
          {
              img:'https://imgs.qunarzz.com/vs_ceph_vs_tts/97d36acc-85d0-449c-af56-e4836e20482c.jpg_480x320_91b0a154.jpg',
              link:'https://fh.dujia.qunar.com/fhxtouch/detail/465932803_?in=2021-03-28&productId=35821755&dep=%E6%9D%AD%E5%B7%9E&query=%E7%8F%A0%E6%B5%B7&newfreetrip=1',
              id:'wanfa_2',
              price:'1870',
              title:'「澳门自由行•住澳门永利皇宫酒店或其他」'
          },
          {
              img:'https://img1.qunarzz.com/vs_ceph_b2c_001/ff65c37f-476d-4b03-8882-89d5d326cf38.png_r_640x420x95_7e0694fa.png',
              link:'https://touch.dujia.qunar.com/p/item/2448549941?tuId=PID2448549941G1767214799',
              id:'wanfa_3',
              price:'4155',
              title:'杭州出发-自由行 感受半岛葡式风情丨澳门3日2晚自由行丨葡京五星酒店✔品奢优选'
          },
          {
              img:'https://img1.qunarzz.com/vs_ceph_b2c_001/79bdf67e-29b5-4d1d-a7ef-99b6a5a7f01b.png_r_640x420x95_b2cc943c.png',
              link:'https://touch.dujia.qunar.com/p/item/3861796515?tuId=PID3861796515G3007585198',
              id:'wanfa_4',
              price:'3775',
              title:'杭州出发-自由行 品奢优选丨澳门3日2晚自由行丨五星瑞吉酒店✔大运河购物广场✔四季名店街'
          }
      ]
    };
  },
  methods: {
    clickNav(index) {
      this.currentIndex = index;
    },
    jumpUrl(link){
      location.href = link;
    }
  },
};
</script>
<style lang='less' scoped='true'>
.wanfa {
  text-align: center;
}
.title {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.wanfaItem {
  &-box{
      width:calc(100% - 20px);
      margin-left:auto;
      margin-right:auto;
  }
  border-radius: 10px;
  width: 170px;
  padding-bottom:14px;
  background-color: #fff;
  float: left;
  &:nth-child(2n+2){
      margin-left:10px;
  }
  &-bottom {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 22px;
    padding-left: 9px;
    padding-right: 9px;
    height:30px;
    .price {
      color: #ff3939;
      font-size: 20px;
      font-weight: 600;
      &:before {
        content: "￥";
        font-size: 12px;
      }
      &:after {
        content: "起";
        font-size: 12px;
      }
    }
    .button {
      a {
        width: 78px;
        height: 24px;
        background: linear-gradient(0deg, #8F09BD, rgba(252, 222, 192, 0.01));
        border-radius: 16px;
        line-height:24px;
        text-align: center;
        color:#fff;
        background-color: #DB40FF;
        font-size:11px;
        display: inline-block;
      }
    }
  }
  &-name {
    font-size: 16px;
    text-align: left;
    padding: 8px;
    padding-top:0;
    padding-bottom:0;
  }
}
.lookMore{
  width:71px;
  margin-top:20px;
  padding-bottom:100px;
}
</style>